export class SetLoading {
  public static readonly type = "[Users] Set loading";
  public constructor(public isLoading: boolean) {}
}
